// @ts-nocheck
import action from 'utils/actionCreators';

export const GET_PAYMENT_ACT_REQUEST = 'PAYMENT_ACT/GET_PAYMENT_ACT_REQUEST';
export const GET_PAYMENT_ACT_SUCCESS = 'PAYMENT_ACT/GET_PAYMENT_ACT_SUCCESS';
export const GET_PAYMENT_ACT_FAILURE = 'PAYMENT_ACT/GET_PAYMENT_ACT_FAILURE';

export const GET_PAYMENT_ACT_BY_ID_REQUEST =
  'PAYMENT_ACT/GET_PAYMENT_ACT_BY_ID_REQUEST';
export const GET_PAYMENT_ACT_BY_ID_SUCCESS =
  'PAYMENT_ACT/GET_PAYMENT_ACT_BY_ID_SUCCESS';
export const GET_PAYMENT_ACT_BY_ID_FAILURE =
  'PAYMENT_ACT/GET_PAYMENT_ACT_BY_ID_FAILURE';

export const ADD_PAYMENT_ACT_REQUEST = 'PAYMENT_ACT/ADD_PAYMENT_ACT_REQUEST';
export const ADD_PAYMENT_ACT_SUCCESS = 'PAYMENT_ACT/ADD_PAYMENT_ACT_SUCCESS';
export const ADD_PAYMENT_ACT_FAILURE = 'PAYMENT_ACT/ADD_PAYMENT_ACT_FAILURE';

export const UPDATE_PAYMENT_ACT_REQUEST =
  'PAYMENT_ACT/UPDATE_PAYMENT_ACT_REQUEST';
export const UPDATE_PAYMENT_ACT_SUCCESS =
  'PAYMENT_ACT/UPDATE_PAYMENT_ACT_SUCCESS';
export const UPDATE_PAYMENT_ACT_FAILURE =
  'PAYMENT_ACT/UPDATE_PAYMENT_ACT_FAILURE';

export const DELETE_PAYMENT_ACT_REQUEST =
  'PAYMENT_ACT/DELETE_PAYMENT_ACT_REQUEST';
export const DELETE_PAYMENT_ACT_SUCCESS =
  'PAYMENT_ACT/DELETE_PAYMENT_ACT_SUCCESS';
export const DELETE_PAYMENT_ACT_FAILURE =
  'PAYMENT_ACT/DELETE_PAYMENT_ACT_FAILURE';

export const OPEN_FORM_MODAL = 'PAYMENT_ACT/OPEN_FORM_MODAL';
export const CLOSE_FORM_MODAL = 'PAYMENT_ACT/CLOSE_FORM_MODAL';
export const OPEN_CONFIRMATION_MODAL = 'PAYMENT_ACT/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'PAYMENT_ACT/CLOSE_CONFIRMATION_MODAL';

export const UPDATE_FORM_FIELD = 'PAYMENT_ACT/UPDATE_FORM_FIELD';
export const RESET_FORM_FIELD = 'PAYMENT_ACT/RESET_FORM_FIELD';

export const UPDATE_SEARCH_TEXT = 'PAYMENT_ACT/UPDATE_SEARCH_TEXT';

export const getPaymentActRequest = action(GET_PAYMENT_ACT_REQUEST, 'payload');

export const getPaymentActByIdRequest = action(
  GET_PAYMENT_ACT_BY_ID_REQUEST,
  'payload',
);

export const addPaymentActRequest = action(ADD_PAYMENT_ACT_REQUEST, 'payload');

export const updatePaymentActRequest = action(
  UPDATE_PAYMENT_ACT_REQUEST,
  'payload',
);

export const deletePaymentActRequest = action(
  DELETE_PAYMENT_ACT_REQUEST,
  'payload',
);

export const openFormModal = action(OPEN_FORM_MODAL);
export const closeFormModal = action(CLOSE_FORM_MODAL);
export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);

export const updateFormField = action(UPDATE_FORM_FIELD, 'payload');
export const resetFormField = action(RESET_FORM_FIELD);

export const updateSearchText = action(UPDATE_SEARCH_TEXT, 'payload');
